'use strict';

var ConfigurationFareBuilderController = function ConfigurationFareBuilderController($scope, dataRetrieverService, dataRetrieverConstantsService, configurationFareBuilderService, configurationService, momentService) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', dataRetrieverConstantsService.SYSTEM_STATUS_CONFIGURATION_FARE_BUILDER_MODE).setCustomSearchCriteriaRules([]);
  $scope.customSave = function (editedRows) {
    return configurationFareBuilderService.save(editedRows);
  };
  $scope.customRemove = function (rowsToBeRemovedFromServer) {
    configurationFareBuilderService.remove(rowsToBeRemovedFromServer);
  };
  $scope.customAddNew = function (row) {
    row.foCarrier = configurationService.getHostCarrier();
    return row;
  };
  $scope.makeExportToCsv = function (data) {
    configurationFareBuilderService.exportToCsv(data);
  };
  $scope.customSaveValidation = function (editedRows, gridData) {
    return configurationFareBuilderService.validate(editedRows, gridData);
  };
};
ConfigurationFareBuilderController.$inject = ['$scope', 'DataRetrieverService', 'DataRetrieverConstantsService', 'ConfigurationFareBuilderService', 'ConfigurationService', 'MomentService'];
module.exports = ConfigurationFareBuilderController;